import { render, staticRenderFns } from "./Widgets.vue?vue&type=template&id=dac3a6e2&"
import script from "./Widgets.vue?vue&type=script&lang=js&"
export * from "./Widgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports